<form *ngIf="workerVehicleFormGroup" [formGroup]="workerVehicleFormGroup">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="capabilityId">Vehículo *</label>
            <p-dropdown [options]="vehicles" formControlName="vehicleId" [required]="true" optionValue="id"
                [filter]="true" filterBy="name" optionLabel="customName" placeholder="Seleccione vehículo" appendTo="body"
                d-form-field-error />                       
            <p-messages *ngIf="selectedVehicle?.notes != null && selectedVehicle?.notes != ''" [value]="[{
                severity: 'info', 
                detail: selectedVehicle.notes
                }]" [closable]="false" />
        </div>    

        <div class="col-6 input-field ">
            <label for="startDate">Desde *</label>
            <p-calendar [firstDayOfWeek]="1" 
            inputId="fromDate"         
            appendTo="body"
            dateFormat="dd/mm/yy"
            formControlName="fromDate" d-form-field-error/>        
          </div>
          <div class="col-6 input-field ">
            <label for="toDate">Hasta *</label>
            <p-calendar [firstDayOfWeek]="1" 
            inputId="toDate"         
            appendTo="body"
            dateFormat="dd/mm/yy"
            formControlName="toDate" d-form-field-error/>
            
          </div>

        
        <div class="col-12 input-field">
            <label for="price">Descontar al operario</label>
            <p-inputSwitch formControlName="deductFromWorker" d-form-field-error (onChange)="toggleFormValidations()"></p-inputSwitch>
        </div>
        
        <!--<div class="col-4 input-field" *ngIf="selectedVehicle?.ownerType == 'WORKER' && workerVehicleFormGroup.get('deductFromWorker')?.value ">
            <label for="price">Importe a descontar</label>
            <input formControlName="deductValue" pInputText type="number" d-form-field-error>
        </div>-->
        <div class="col-3 input-field" *ngIf="workerVehicleFormGroup.get('deductFromWorker')?.value">
            <label for="price">Precio</label>
            <input formControlName="price" pInputText type="number" d-form-field-error (input)="calculatePrices()">
        </div>

        <div class="col-3 input-field" *ngIf="workerVehicleFormGroup.get('deductFromWorker')?.value">
            <label for="price">% gastos de gestión</label>
            <input formControlName="managementFee" pInputText type="number" (input)="calculatePrices()" d-form-field-error  suffix=" %" >
            <label class="mt-2">
                {{ managementFee | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>

        
        <div class="col-3 input-field" *ngIf="workerVehicleFormGroup.get('deductFromWorker')?.value">
            <label for="code">Impuestos(%)</label>
            <p-dropdown formControlName="taxId" [options]="taxes"
                optionLabel="name" optionValue="id" appendTo="body" filterBy="name"
                placeholder="Seleccione opción" (onChange)="calculatePrices()" d-form-field-error></p-dropdown>                            
            <label class="mt-2">
                {{ taxAmount | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>
        <div class="col-3 input-field"  *ngIf="workerVehicleFormGroup.get('deductFromWorker')?.value">
            <label class="mb-3" for="total">Total</label>
            <span class="mt-2">
                {{ total | currency:'EUR':'symbol':'1.2-2' }}                
            </span>
        </div>        
          
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && workerVehicle.id" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
            (click)="save()"></p-button>
    </div>

</form>